import { useSelector } from 'react-redux';

import { selectPageType } from '../selectors';
import { EPageType } from '../types/page/pageType';

export function useGetShareButtonText() {
  const pageType = useSelector(selectPageType);

  switch (pageType) {
    case EPageType.Homeowner:
      return undefined;
    case EPageType.Tenant:
      return 'Предложить собственнику';
    case EPageType.Agent:
      return undefined;
  }
}
